module.exports = __webpack_public_path__ + "img/vetting-process.36bac828.png";